import clsx from 'clsx'
import React from 'react'
import { Image } from '@/components/atoms/Image/Image'
import { IntegrationItemProps } from '@/components/molecules/IntegrationItem/types'
import { Paragraph } from '@/components/atoms/MarkdownElements/MarkdownElements'

export function IntegrationItem({ logo, name, description, custom_css_class, custom_id }: IntegrationItemProps) {
  return (
    <div
      className={`p-24 flex netbook:flex-col gap-24 border-1 border-primary-300 rounded w-full desktop:w-288 h-full desktop:max-h-[230px] hover:bg-primary-100 transition cursor-pointer ${custom_css_class || ''}`}
      id={custom_id}
    >
      {logo && (
        <Image
          fixed
          data={logo}
          imgClassName="w-48 laptop:w-64 h-auto tablet:w-64 tablet:mr-0 "
          width={70}
          height={64}
          className={clsx('w-48 laptop:w-64 max-h-[64px] h-full')}
        />
      )}
      <div className="flex flex-col text-text-dark-900 gap-4">
        {name && <p className="text-bodyL font-bold font-poppins">{name}</p>}
        {description && <Paragraph className="text-bodyS line-clamp-3">{description}</Paragraph>}
      </div>
    </div>
  )
}
